// Copyright (c) 2022 by Move Closer

import { ImageData, IRelatedService, ModuleContentResolver } from '../../contexts'
import { logger } from '../../support'

import { resolveImage, resolveLink } from '../resolvers'

import { CTABoxModuleContent, CTABoxModuleContentInput, CTABoxSection } from './CTABox.contracts'
import { ResolvedLink } from '../partials'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const resolveCTAModuleContent: ModuleContentResolver<CTABoxModuleContentInput, CTABoxModuleContent> =
  async (input: CTABoxModuleContentInput, relatedService: IRelatedService): Promise<CTABoxModuleContent> => {
    let cta: CTABoxSection | undefined
    let image: ImageData | null = null

    try {
      image = await resolveImage(input.image, relatedService)
    } catch (e) {
      logger(e, 'warn')
    }

    if (typeof input.cta !== 'undefined' && input.cta.action) {
      try {
        let actionLink: ResolvedLink | null = null

        if (input.cta.action.relatedTarget) {
          actionLink = await resolveLink(input.cta.action, relatedService)
        } else {
          actionLink = input.cta.action as ResolvedLink
        }

        cta = {
          ...input.cta,
          action: actionLink
        }
      } catch (e) {
        logger(e, 'warn')
      }
    }

    return {
      ...input,
      image,
      cta
    }
  }
